<template>
	<div>
		<div class="activeClient">
			<v-container class="grey lighten-5">
				<v-row no-gutters>
					<v-col cols="12" sm="12" md="12">
						<v-card class="pa-2" outlined tile>
							<div>
								<section>
									<div class="container">
										<div class="column">
											<AdminMarketPlaceProductCard
												v-for="product of marketProducts"
												:key="product.product_id"
												:product="product"
												class="card-columns"
                        @refresh-products="refreshProducts"
											/>                      
										</div>
									</div>
								</section>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import AdminMarketPlaceProductCard from '@/components/ui/AdminMarketPlaceProductCard.vue'

export default {
	components: {
    	AdminMarketPlaceProductCard
	},
	data() {
	    return {
    		marketProducts: []
	    }
  	},
	async created() {
	    this.marketProducts = await this.$store.dispatch('marketPlace/fetchMarketPlaceProductsForAdmin')
	},
  methods: {
    async refreshProducts() {
	    this.marketProducts = await this.$store.dispatch('marketPlace/fetchMarketPlaceProductsForAdmin')
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  background: var(--bg-light)!important;
  color: var(--bright) !important;
  border: none !important;
}
.fieldPrice {
  width: 30%;
}

.inp {
  border: none;
  border-bottom: 0.2px solid var(--bg);
  padding: 5px 10px;
  outline: none;
  margin-bottom: 1.2em;
  background-color: var(--grey-superlight);
}
.inp:hover {
  border-color: var(--primaryDark);
}

[placeholder]:focus::-webkit-input-placeholder {
  transition: text-indent 0.4s 0.4s ease;
  text-indent: -100%;
  opacity: 1;
}

[v-cloak] {
  display: none;
}

.unitProductsEmpty {
  display: none; //! none when FIRST unitProduct with this client_id is already found in db //
}
.activeClient {
  // display: none; //! none when NO unitProduct with this client_id is found in db //
}

.btn {
  border: solid 1px var(--bg);
  color: var(--bg);
  font-weight: normal !important;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}

.product-cards {
  margin-top: 20px;
  margin-left: 0;
  padding-left: 0px;
}

.showOverall {
  border: none;
  color: var(--bright);
  background-color: var(--primaryDark) !important;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.trash-Icon {
  background: var(--bg-superLight);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 235px;
  height: 35px;
  right: 0;
  position: relative;
  text-align: left; 
  cursor: pointer;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

  .column {
    display: flex;
    flex-flow: wrap;
    height: 100%;
  }

@media (max-width: 500px) {
  .column {
    display: inherit;
  }
}


// Breakpoints
$bp-maggie: 15em;
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

a {
  color: var(--primaryDark);

  &:hover,
  &:focus {
    color: var(--primaryDark);
  }
}

.container {
	// margin-bottom: 2em;

  @media (min-width: $bp-bart) {
    // margin: 2%;
  }

  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;

  @media (min-width: $bp-bart) {
    font-size: 0.9em;
  }

  @media (min-width: $bp-marge) {
    font-size: 1em;
  }

  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px;
    width: 1px;
    overflow: hidden;

    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }

    th {
      background-color: var(--bg-light);
      border: 1px solid var(--bg-light);
      font-weight: normal;
      text-align: center;
      color: var(--bright);

      &:first-of-type {
        text-align: left;
      }
    }
  }

  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }

  tr {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row;
    }
  }

  th,
  td {
    padding: 0.5em;
    vertical-align: middle;

    @media (min-width: $bp-lisa) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-cell;
      padding: 0.5em;
    }

    @media (min-width: $bp-marge) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $bp-homer) {
      padding: 0.75em;
    }
  }

  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;

    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }

  tfoot {
    font-size: 0.8em;
    font-style: italic;

    @media (min-width: $bp-marge) {
      font-size: 0.9em;
    }
  }

  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block
      display: table-row-group;
    }

    tr {
      margin-bottom: 1em;

      @media (min-width: $bp-bart) {
        // Undo display: block
        display: table-row;
        border-width: 1px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94, 93, 82, 0.1);
        }
      }
    }

    th[scope='row'] {
      background-color: var(--bg-light);
      color: white;

      @media (min-width: $bp-lisa) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
      }

      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94, 93, 82, 1);
        text-align: left;
      }
    }

    td {
      text-align: right;

      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light);
        border-bottom: 1px solid var(--bg-light);
        text-align: center;
      }

      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid var(--bg-light);
        }
      }
    }

    td[data-type='currency'] {
      text-align: right;
    }

    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: 0.8em;
      color: rgba(94, 93, 82, 0.75);

      @media (min-width: $bp-lisa) {
        font-size: 0.9em;
      }

      @media (min-width: $bp-bart) {
        // Don’t show data-title labels
        content: none;
      }
    }
  }
}

@media screen and (max-width: 500px){
  .changeStockMobile {
  letter-spacing: 0;
  margin-left: 10px;
}
  .trash-Icon {
  width: 175px;
}
}

</style>